<template>
    <div class="page-table haberTanim mainDiv listPage" id="affix-container">
        <div class="card-base baslikBg animated fadeInUp">{{$t("src.views.apps.slider.liste.baslikYayin")}}</div>
        <div class="page-header card-base card-shadow--medium animated fadeInUp">
            <el-col :span="23">
                <div>
                    <el-radio-group size="small" v-on:change="handleChange($event)" v-model="radio" fill="#E5F5F9"
                                    text-color="gray">
                        <el-radio-button label="1">
                            <i class="mdi mdi-image-filter-none mdi-24px" style="color: #13ce66; margin-right: 5px"></i>
                            <transition
                                    name="slide-fade"><label v-if="selectIcon==='1'">{{$t("src.views.apps.slider.liste.yayinda")}}</label>
                            </transition>
                        </el-radio-button>
                        <el-radio-button label="0">
                            <i class="mdi mdi-image-filter-none mdi-24px" style="color: #ec205f; margin-right: 5px"></i>
                            <transition
                                    name="slide-fade"><label v-if="selectIcon==='0'">{{$t("src.views.apps.slider.liste.pasif")}}</label>
                            </transition>
                        </el-radio-button>
                    </el-radio-group>
                </div>
            </el-col>
            <el-col :span="1">
                <el-tooltip :content='$t("src.views.apps.slider.tanimlama.title")'
                            :open-delay="500"
                            placement="bottom">
                    <el-button
                            v-on:click="routeSlider('Slider Tanımla')"
                            style="float: right"
                            size="mini"
                            icon="el-icon-plus">
                    </el-button>
                </el-tooltip>
            </el-col>
            <el-table
                    :data="sliderList"
                    border
                    stripe
                    style="width: 100%">
                <el-table-column
                        label="Sıra"
                        type="index">
                </el-table-column>
                <el-table-column
                        prop="anaBaslik"
                        label="Başlık"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="dil.de.anaBaslik"
                        label="Başlık (Almanca)"
                        width="auto">
                </el-table-column>
                <el-table-column
                        prop="dil.en.anaBaslik"
                        label="Başlık (İngilizce)"
                        width="auto">
                </el-table-column>
                <el-table-column
                        label="İşlem"
                        align="right"
                        width="150">
                    <template slot-scope="scope">
                        <el-tooltip :content='$t("src.views.apps.slider.liste.sliderduzenle")'
                                    :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-if="root || yetkili"
                                    v-on:click="routeSlider('Slider Düzenle',scope.row)"
                                    type="text"
                                    class="buttonEdit"
                                    icon="el-icon-edit">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip :content='$t("src.views.apps.slider.liste.sliderkaldir")' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-if="selectIcon==='1' && (root || yetkili)"
                                    class="buttonDel"
                                    @click="deleteDialogVisible = true; selection = scope.row; selectionIndex = scope.$index"
                                    type="text"
                                    icon="mdi mdi-pause mdi-24px">
                            </el-button>
                        </el-tooltip>
                        <el-tooltip :content='$t("src.views.apps.slider.liste.sliderkaldir")' :open-delay="500"
                                    placement="bottom">
                            <el-button
                                    v-if="selectIcon==='0' && (root || yetkili)"
                                    type="text"
                                    @click="addDialogVisible = true; selection = scope.row; selectionIndex = scope.$index"
                                    icon="mdi mdi-play mdi-24px">
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    background
                    layout="sizes,prev, pager, next, jumper, total"
                    :total="total"
                    @size-change="handleSizeChange"
                    @current-change="pageChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page.sync="page"
                    :next-click.sync="page"
                    :prev-click.sync="page"
                    @next-click="pageChange"
                    @prev-click="pageChange">
            </el-pagination>
        </div>
        <el-dialog
                :title='$t("src.views.apps.slider.liste.uyari")'
                :visible.sync="deleteDialogVisible"
                width="30%"
                center>
            <span>'{{selection.anaBaslik}}' {{$t('src.views.apps.slider.liste.slidertaslak')}}</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="sliderDurumDegis(selection,selectionIndex,sliderList,'0'), deleteDialogVisible = false"></el-button>
                    <el-button type="danger" size="mini" icon="el-icon-close"
                               @click="deleteDialogVisible = false"></el-button>
                </span>
        </el-dialog>
        <el-dialog
                :title='$t("src.views.apps.slider.liste.uyari")'
                :visible.sync="addDialogVisible"
                width="30%"
                center>
            <span>'{{selection.anaBaslik}}' {{$t('src.views.apps.slider.liste.slideradd')}}</span>
            <span slot="footer" class="dialog-footer">
                    <el-button icon="el-icon-check"
                               type="success"
                               size="mini"
                               @click="sliderDurumDegis(selection,selectionIndex,sliderList,'1'), addDialogVisible = false"></el-button>
                    <el-button type="danger" size="mini" icon="el-icon-close"
                               @click="addDialogVisible = false"></el-button>
                </span>
        </el-dialog>
    </div>

</template>

<script>
    import sliderService from '../../../WSProvider/SliderService'
    import notification from '../../../notification'
    import functions from '../../../functions'
    import EventBus from '@/components/event-bus'

    let base64 = require('base64_js');
    let userDataKader = "";

    export default {
        name: "SliderListesi",
        data() {
            return {
                selectIcon: '1',
                radio: '1',
                root: false,
                yetkili: false,
                yetkiList: {
                    sliderGuncelleme: false,
                    sliderSil: false,
                },
                dil: 'tr',
                pathh: "http://www.estasmedical.com/",
                sizes: 10,
                sizesTaslak: 10,
                page: 0,
                pageTaslak: 0,
                postPage: 0,
                postPageTaslak: 0,
                total: null,
                totalTaslak: null,
                sliderList: [],
                deleteDialogVisible: false,
                addDialogVisible: false,
                selection: '',
                selectionIndex: '',
            }
        },
        mounted() {
            let self = this;
            if (localStorage.getItem("userDataKader")) {
                userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
                if (userDataKader["tur"]) {
                    if (userDataKader["tur"] === '1') {
                        self.root = true;
                        self.yetkiList.sliderSil = true;
                        self.yetkiList.sliderGuncelleme = true;
                    }
                    else if (userDataKader["tur"] === '2') {
                        self.yetkili = true;
                        self.yetkiList.sliderSil = true;
                        self.yetkiList.sliderGuncelleme = true;
                    }
                }
                if (userDataKader["yetki"]) {
                    userDataKader["yetki"].forEach(function (value) {
                        switch (value.yetkiKodu) {
                            case 'YK-945722':
                                self.yetkiList.sliderGuncelleme = true;
                                self.yetkiList.sliderSil = true;
                                break;
                            case 'YK-741576':
                                self.yetkiList.sliderSil = true;
                                break;
                        }
                    });
                }
            }
            EventBus.$on('sliderList', function(bool){
                if(bool){
                    self.getSliderList();
                }
            });

            this.getSliderList();
        },
        methods: {
            handleSizeChange(val) {
                this.sizes = val;
                this.getSliderList();
            },
            pageChange(val) {
                this.postPage = (val - 1) * this.sizes;
                this.getSliderList();
            },
            handleChange(event) {
                this.selectIcon = event;
                this.getSliderList();
            },
            getSliderList() {
                sliderService.sliderList( this.selectIcon, this.postPage, this.sizes).then((response) => {
                    if (response.status === 200) {
                        this.sliderList = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                });
            },
            sliderDurumDegis(selection, index, list, durum) {
                sliderService.sliderDurumGuncelle(selection.sliderId, durum).then((response) => {
                    if (response.status === 200) {
                        switch (durum) {
                            case '0':
                                list.splice(index, 1);
                                notification.Status("success", this, "Slider taslağa taşındı.");
                                break;
                            case '1':
                                list.splice(index, 1);
                                notification.Status("success", this, "Slider yayına alındı.");
                                break;
                        }
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },
            routeSlider(name, scope) {
                var tabList = this.$store.state.tabList;
                if (scope) {
                    this.$store.commit('changeUpdateKodu', scope.sliderId);
                }
                var header = functions.linkTemizle(name.replace(" ", ""));
                var obj = tabList.find(data => data.title === name);
                if (obj === undefined) {
                    tabList.push({
                        title: name,
                        name: header,
                        contentName: header
                    });
                    this.$store.commit('changeTabList', tabList);
                    this.$store.commit('changeActiveTabs', header);
                } else {
                    this.$store.commit('changeActiveTabs', header);
                }
            }
        }
    }

    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")

    }
</script>

<style lang="scss" scoped>
    .el-pagination {
        margin-top: 20px;
        float: right;
    }

    .el-radio-button--mini .el-radio-button__inner label {
        position: relative;
        bottom: 5px;
    }

    .kaldirilmis {
        background: #ec205f;
        color: white;
        font-weight: bold;
        font-size: 16px;
        padding: 10px
    }

</style>
<style lang="scss">
    .slide-fade-enter-active {
        transition: all .3s ease;
    }


    @media (min-width: 768px) {
        .el-radio-button--mini .el-radio-button__inner {
            padding: 0 10px !important;
            font-size: 11px;
            border-radius: 0;
        }
    }


    .slide-fade-leave-active {
        transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }
</style>
